import React from 'react';
import { hydrate } from 'react-dom';
import Loadable from 'react-loadable';
import App from './containers/App';

if (module.hot) {
  module.hot.accept();
}

Loadable.preloadReady().then(() => {
  // eslint-disable-next-line react/jsx-filename-extension
  hydrate(<App />, document.getElementById('root'));
});
